import { graphql, commitMutation, type Environment } from 'react-relay';

import type {
	standaloneChartsVizCreateMutation,
	standaloneChartsVizCreateMutation$data,
} from './__generated__/standaloneChartsVizCreateMutation.graphql';

/**
 * Creates a standalone chart via Relay commitMutation.
 *
 * Equivalent to the legacy CREATE_STANDALONE_CHART_QUERY via performGqlFetch,
 * but uses the Relay environment for request execution.
 */
export async function createStandaloneChart(
	environment: Environment,
	variables: standaloneChartsVizCreateMutation['variables'],
): Promise<standaloneChartsVizCreateMutation$data> {
	return new Promise((resolve, reject) => {
		commitMutation<standaloneChartsVizCreateMutation>(environment, {
			mutation: graphql`
				mutation standaloneChartsVizCreateMutation(
					$chart: AVPChartInput!
					$cloudId: ID!
					$containerAri: ID
					$workspaceAri: ID
					$integrationId: AVPIntegrationId
				) {
					avp_createStandaloneChart(
						input: {
							chart: $chart
							cloudId: $cloudId
							containerAri: $containerAri
							workspaceAri: $workspaceAri
							integrationId: $integrationId
						}
					) @optIn(to: "AVP-standalone-charts") {
						success
						avpVizUrl
						chart {
							id
							chartType
						}
						errors {
							message
							extensions {
								statusCode
							}
						}
					}
				}
			`,
			variables,
			onCompleted: (response) => {
				resolve(response);
			},
			onError: (error) => {
				reject(error);
			},
		});
	});
}
